export const opDataStore = {
  state: {
    isInvestigating: false,
    investigatingRowData: {},
    PageTitle: '',
    WHBL_item_sent: {},
    NotificationItemData: {}
  },
  mutations: {
    setWHBLItem (state, data) {
      state.WHBL_item_sent = data
    },
    setInvestigationStatus (state, data) {
      state.isInvestigating = data.status
      state.investigatingRowData = data.rowData
    },
    setRequestPageTitle (state, data) {
      state.PageTitle = data
    },
    clearAllState (state) {
      state.isInvestigating = false
      state.investigatingRowData = {}
      state.PageTitle = ''
      state.WHBL_item_sent = {}
    },
    setNotificationItemData (state, payload) {
      state.NotificationItemData = payload
    }
  },
  actions: {
    ClearOperData (context) {
      context.commit('clearAllState')
    }
  },
  getters: {
    getWHBL_item_sent (state) {
      return state.WHBL_item_sent
    },
    getInvestigationStatus (state) {
      return state.isInvestigating
    },
    getInvestigatingRequestData (state) {
      return state.investigatingRowData
    },
    getNotificationItemData (state) {
      return state.NotificationItemData
    },
    getPageTitle (state) {
      return state.PageTitle
    }
  }
}
